import { render, staticRenderFns } from "./UploadMedia.vue?vue&type=template&id=384abea8&scoped=true&"
import script from "./UploadMedia.vue?vue&type=script&lang=js&"
export * from "./UploadMedia.vue?vue&type=script&lang=js&"
import style0 from "./UploadMedia.vue?vue&type=style&index=0&id=384abea8&prod&scoped=true&lang=css&"
import style1 from "./UploadMedia.vue?vue&type=style&index=1&id=384abea8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384abea8",
  null
  
)

export default component.exports